/**
 * PDP Size Chart — Inches/cm toggle + Gender audience switch.
 * Default unit is always Inches when the modal opens (no saved preference).
 * Reuses Dawn ModalDialog open/close.
 */
(function () {
  const ROOT_SELECTOR = '[data-size-chart]';
  const MODAL_SELECTOR = '#PopupModal-size-chart';
  const UNIT_BTN = '.size-chart__unit-btn';
  const DEFAULT_UNIT = 'in';
  const TITLE_MEN = "Men's Size Guide";
  const TITLE_WOMEN = "Women's Size Guide";

  function getRoot(fromNode) {
    if (!fromNode) return document.querySelector(ROOT_SELECTOR);
    return fromNode.closest(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
  }

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function setUnit(root, unit) {
    if (!root) return;
    const next = unit === 'cm' ? 'cm' : 'in';
    root.querySelectorAll(UNIT_BTN).forEach(function (btn) {
      const active = btn.getAttribute('data-unit') === next;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-in][data-cm]').forEach(function (cell) {
      cell.textContent = next === 'cm' ? cell.getAttribute('data-cm') : cell.getAttribute('data-in');
    });
  }

  function resetToDefaultUnit() {
    setUnit(getRoot(), DEFAULT_UNIT);
  }

  function setAudience(root, audience) {
    if (!root) return;
    const next = audience === 'men' ? 'men' : 'women';
    root.setAttribute('data-audience', next);

    const title = root.querySelector('[data-size-chart-title]');
    if (title) title.textContent = next === 'men' ? TITLE_MEN : TITLE_WOMEN;

    root.querySelectorAll('[data-size-chart-panel]').forEach(function (panel) {
      const match = panel.getAttribute('data-size-chart-panel') === next;
      panel.classList.toggle('is-active', match);
      if (match) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function genderFromChangeEvent(event) {
    const target = event.target;
    if (!target || target.type !== 'radio' || !target.checked) return null;

    const fieldset = target.closest('fieldset.product-form__input');
    if (!fieldset) return null;

    const labelEl = fieldset.querySelector('.form__label, legend.form__label');
    const optionName = (labelEl ? labelEl.textContent : '').replace(/:/g, '').trim().toLowerCase();
    if (optionName !== 'gender') return null;

    const value = (target.value || '').trim().toLowerCase();
    if (value === 'men') return 'men';
    if (value === 'women') return 'women';
    return null;
  }

  function onClick(event) {
    const btn = event.target.closest(UNIT_BTN);
    if (!btn) return;
    const root = getRoot(btn);
    if (!root) return;
    event.preventDefault();
    setUnit(root, btn.getAttribute('data-unit'));
  }

  function onChange(event) {
    const audience = genderFromChangeEvent(event);
    if (!audience) return;
    const root = getRoot();
    if (!root || root.getAttribute('data-has-gender') !== 'true') return;
    setAudience(root, audience);
  }

  function watchModalOpen(modal) {
    if (!modal || modal.dataset.sizeChartUnitWatch === 'true') return;
    modal.dataset.sizeChartUnitWatch = 'true';

    const observer = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        resetToDefaultUnit();
      }
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function initModalWatch() {
    watchModalOpen(getModal());
  }

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalWatch);
  } else {
    initModalWatch();
  }

  // ModalDialog moves itself to document.body; re-bind if needed after late paint.
  document.addEventListener('shopify:section:load', initModalWatch);
  setTimeout(initModalWatch, 0);
})();
